import React from 'react';
import { useInternationalization } from '../../features/i18n';

const SpecialRequiredLabel = () => {
  const { language } = useInternationalization()
  const label = language.name === 'en' ? 'Cannot be both empty. Fill in either or both.'
    : 'Tidak boleh kosong keduanya. Isi salah satu atau semua.'

  return (
    <p className="text-sm text-gray-500 ">*{label}</p>
  )
}

export { SpecialRequiredLabel }
